import { pickPath } from '@hivebrite/utils';

import { type User } from 'hb-react/types';

export const getNewsIndexPath = ({
  currentUser,
  topicId,
  whiteLabelTopic = false,
}: {
  currentUser?: User | null;
  topicId?: number;
  whiteLabelTopic?: boolean;
} = {}) =>
  pickPath({
    userId: currentUser?.id,
    topicId,
    isWLTopic: whiteLabelTopic,
    paths: {
      networkFO: Routes.private_frontoffice_news_index_path,
      networkPO: Routes.private_publicoffice_news_index_path,
      topicFO: Routes.private_frontoffice_topics_news_index_path,
      topicPO: Routes.private_publicoffice_topics_news_index_path,
    },
  })();
